<template>
    <div>
      <!--退款进行时-->
      <div class="logindiv" id="AddForm_orderI">
        <div class="loginForm">
          <div style="width: 100%;height: 40px;background-color: #2d2d2d;margin: 0 auto;">
            <span style="line-height: 40px;color: #FFFFFF;font-size: 14px;float: left;margin-left: 20px;">
              选择退款形式
            </span>
            <span style="line-height: 40px;color: #FFFFFF;font-size: 14px;float: right;margin-right: 20px;">
              <a href="javascript:;" @click="closeRE">
                <i class="el-icon-close"></i>
              </a>
            </span>
          </div>
          <div style="width: 300px;margin: 0 auto;">
            <el-form :model="AddForm" ref="AddForm" style="margin-top: 40px;">
              <el-form-item prop="type">
                <el-select v-model="AddForm.type" class="elInput">
                  <el-option label="模式一:收取2元手续费" value="1"></el-option>
                  <el-option label="模式二:收取订单一半价钱的手续费" value="2"></el-option>
                  <el-option label="模式三:不收取手续费" value="3"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" :loading="buttonloading" style="width: 150px;" @click='ARefundOrder'>提交</el-button>
              </el-form-item>
            </el-form>
          </div>
          <br>
        </div>
      </div>
      <!--订单详情-->
      <div>
        <div class="Orderinfordiv" id="Orderinformain_orderI">
          <div class="OrderinforForm">
            <!--头部标签-->
            <div style="width: 100%;height: 40px;background-color: #2d2d2d;">
              <span style="line-height: 40px;color: #FFFFFF;font-size: 14px;float: left;margin-left: 20px;">
                订单详情
                <span v-if="orderinforList.type=='0'">（等待付款）</span>
                <span v-else-if="orderinforList.type=='1'">（等待发货）</span>
                <span v-else-if="orderinforList.type=='2'">（等待收货）</span>
                <span v-else-if="orderinforList.type=='3'">（待评价）</span>
                <span v-else-if="orderinforList.type=='4'">（已完成）</span>
                <span v-else-if="orderinforList.type=='6'">（备货中）</span>
                <span v-else-if="orderinforList.type=='8'">（退款申请驳回）</span>
                <span v-else-if="orderinforList.type=='-1'">（已取消）</span>
                <span v-else-if="orderinforList.type=='5'">（退款中）</span>
                <span v-else-if="orderinforList.type=='7'">（退款成功/已取消）</span>
                <span v-else-if="orderinforList.type=='-2'">用户已删除</span>
              </span>
              <span style="line-height: 40px;color: #FFFFFF;font-size: 14px;float: right;margin-right: 20px;">
                <a href="javascript:;" @click="closeOrderInformation()">
                  <i class="el-icon-close"></i>
                </a>
              </span>
            </div>
            <!--主体结构-->
            <div class="playlistbox_botton" v-loading="loadingxx">
              <div style="margin-bottom: 10px;margin-top: 10px;overflow: hidden;">
                <div style="line-height: 26px;width: 900px;overflow: hidden;">
                  <div style="width: 880px;margin: 0 auto;">
                    <div style="font-size: 20px;color: #909090;">
                      订单详情
                    </div>
                  </div>
                </div>
                <!--订单编号-->
                <div style="margin-top: 10px;color: #909090;float: left;width: 900px;overflow: hidden;margin-bottom: 11px;">
                  <div style="width: 880px;margin: 0 auto;">
                    <div style="float: left;">
                      订单号：{{orderinforList.id}}
                    </div>
                    <!--操作按钮-->
                    <div style="float: right;" v-if="orderinforList.type!='-1'">
                      <el-button type="primary" :loading="buttonloading" size="mini" @click="UserGetCode(orderinforList)" v-if="orderinforList.type=='2'">重发取货码</el-button>
                      <el-button type="primary" :loading="buttonloading" size="mini" @click="openRE(orderinforList)" v-if="orderinforList.type=='5'">同意退款</el-button>
                      <el-button type="primary" :loading="buttonloading" size="mini" @click="openRE(orderinforList)" v-else-if="orderinforList.type=='1'||orderinforList.type=='2'||orderinforList.type=='6'||orderinforList.type=='8'">退款</el-button>
                      <el-button type="success" :loading="buttonloading" size="mini" @click="BeiHuoOrder(orderinforList)" v-if="orderinforList.type=='1'||orderinforList.type=='8'">备货</el-button>
                      <el-button type="success" :loading="buttonloading" size="mini" @click="FaHuoOrder(orderinforList)" v-if="orderinforList.type=='6'">发货</el-button>
                      <el-button type="success" :loading="buttonloading" size="mini" @click="NoPeisongOrderShouHuo(orderinforList)" v-else-if="orderinforList.type=='2'&&orderinforList.peisong=='0'">收货</el-button>
                      <el-button type="success" :loading="buttonloading" size="mini" @click="ANORefundOrder(orderinforList)" v-else-if="orderinforList.type=='5'">驳回退款</el-button>
                    </div>
                  </div>
                </div>
                <!--分割线-->
                <hr>
                <!--商品与订单状态-->
                <div style="width: 870px;overflow: hidden;margin: 0 auto;">
                  <div style="color: #ff6700;font-size: 17px;" v-if="orderinforList.type=='0'">
                    等待付款
                  </div>
                  <div style="color: #ff6700;font-size: 17px;" v-else-if="orderinforList.type=='1'">
                    等待发货
                  </div>
                  <div style="color: #ff6700;font-size: 17px;" v-else-if="orderinforList.type=='2'">
                    等待收货
                  </div>
                  <div style="color: #ff6700;font-size: 17px;" v-else-if="orderinforList.type=='3'">
                    已成交（待评价）
                  </div>
                  <div style="color: #ff6700;font-size: 17px;" v-else-if="orderinforList.type=='4'">
                    已成交
                  </div>
                  <div style="color: #ff6700;font-size: 17px;" v-else-if="orderinforList.type=='6'">
                    备货中
                  </div>
                  <div style="color: #ff6700;font-size: 17px;" v-else-if="orderinforList.type=='8'">
                    退款申请驳回
                  </div>
                  <div style="color: #ff6700;font-size: 17px;" v-else-if="orderinforList.type=='-1'">
                    已取消
                  </div>
                  <div style="color: #ff6700;font-size: 17px;" v-else-if="orderinforList.type=='5'">
                    退款中（等待商家确认）
                  </div>
                  <div style="color: #ff6700;font-size: 17px;" v-else-if="orderinforList.type=='7'">
                    退款成功/已取消
                  </div>
                  <div style="color: #ff6700;font-size: 17px;" v-else-if="orderinforList.type=='-2'">
                    用户已删除
                  </div>
                  <div style="margin-top: 5px;" v-if="orderinforList!=''">
                    <el-collapse>
                      <el-collapse-item :title="getNewTypetime(orderinforList.timeList[0])">
                        <div>
                          <el-timeline>
                            <el-timeline-item
                              v-for="(activity, index) in orderinforList.timeList"
                              :key="index"
                              :timestamp="activity.time*1 | formatDate"
                              color="#0bbd87">
                              {{PDTimeType(activity.type)}}
                            </el-timeline-item>
                          </el-timeline>
                        </div>
                      </el-collapse-item>
                    </el-collapse>
                  </div>
                  <!--商品列表-->
                  <div style="overflow: hidden;margin-bottom: 5px;margin-top: 10px;" v-for="(goods,index) in orderinforList.goodsList" :key="index"><!--多个商品循环区域-->
                    <div style="width: 102px;height: 102px;float: left;border: 1px solid #aaaaaa;">
                      <img :src="goods.image" alt="" width="100px" height="100px">
                    </div>
                    <div style="float: left;margin-left: 25px;font-size: 14px;">
                      <div style="line-height: 50px;width: 730px;">
                        {{goods.name}}
                      </div>
                      <div style="line-height: 50px;" v-if="goods.g_id=='0'">
                        {{getFmoney(orderinforList.sum_money*1,1)}}元✖{{1}}
                      </div>
                      <div style="line-height: 50px;" v-else>
                        {{getFmoney(goods.money*1,goods.discount)}}元✖{{goods.number}}
                      </div>
                    </div>
                  </div>
                </div>
                <!--分割线-->
                <hr>
                <!--收货信息-->
                <div style="width: 880px;overflow: hidden;margin: 0 auto;margin-top: 5px;">
                  <div style="font-size: 20px;font-weight: normal;color:#000;overflow:hidden;margin-bottom: 5px;">收货信息</div>
                  <p class='orderxx_p'>姓<span style="color:#fff">姓名</span>名：{{orderinforList.consignee}}</p>
                  <p class='orderxx_p'>联系电话：{{orderinforList.phone}}</p>
                  <p class='orderxx_p'>收货地址：{{orderinforList.address}}</p>
                </div>
                <!--分割线-->
                <hr>
                <!--支付信息-->
                <div style="width: 880px;overflow: hidden;margin: 0 auto;margin-top: 5px;">
                  <div style="font-size: 20px;font-weight: normal;color:#000;overflow:hidden;margin-bottom: 5px;">支付方式</div>
                  <p class='orderxx_p'>支付方式：在线支付</p>
                </div>
                <!--分割线-->
                <hr>
                <!--订单金额总计-->
                <div>
                  <table border="0" align="left" width="50%" v-if="orderinforList.refund_money*1!=0">
                  	<tr>
                  		<td width="20%"><div align="left">退款金额：</div></td>
                  		<td><div align="left">{{parseFloat(orderinforList.refund_money).toFixed(2)}}元</div></td>
                  	</tr>
                  	<tr>
                  		<td><div align="left">手续费：</div></td>
                  		<td><div align="left">{{parseFloat(parseFloat(orderinforList.sum_money)-parseFloat(orderinforList.refund_money)).toFixed(2)}}元</div></td>
                  	</tr>
                  </table>
                  <table border="0" align="right" width="50%" >
                  	<tr>
                  		<td width="70%"><div align="right">商品总价：</div></td>
                  		<td><div align="right" style="color:#ff6700;">{{parseFloat(parseFloat(orderinforList.sum_money)-parseFloat(orderinforList.freight)).toFixed(2)}}元</div></td>
                  	</tr>
                  	<tr>
                  		<td><div align="right">运费：</div></td>
                  		<td><div align="right" style="color:#ff6700;">{{parseFloat(orderinforList.freight).toFixed(2)}}元</div></td>
                  	</tr>
                  	<tr>
                  		<td><div align="right">&nbsp;</div></td>
                  		<td><div align="right">&nbsp;</div></td>
                  	</tr>
                  	<tr>
                  		<td><div align="right">应付金额：</div></td>
                  		<td><div align="right" style="color:#ff6700;"><span style="font-size:30px;">{{parseFloat(orderinforList.sum_money).toFixed(2)}}</span>元</div></td>
                  	</tr>
                  </table>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
      <div>
        <el-container>
          <el-header style="background-color:white;margin-top: 5px;height: 40px;">
            <el-form :inline="true" :model="formInline" class="demo-form-inline" size="mini">
              <el-form-item>
                <el-button type="success" :loading="buttonloading" class="btn" @click="exportExcel()"><i class="el-icon-upload2"></i> 导出Excel表格</el-button>
              </el-form-item>
              <el-form-item label="订单号">
                <el-input v-model="formInline.id" placeholder="订单号" class="elInput"></el-input>
              </el-form-item>
              <el-form-item label="收货电话">
                <el-input v-model="formInline.phone" placeholder="收货电话" class="elInput"></el-input>
              </el-form-item>
              <el-form-item label="订单状态">
                <el-select v-model="formInline.type" placeholder="订单状态" style="width: 120px;">
                  <el-option
                    v-for="item in options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="是否配送">
                <el-select v-model="formInline.peisong" class="elInput" style="width: 120px;">
                  <el-option label="全部" value=""></el-option>
                  <el-option label="是" value="1"></el-option>
                  <el-option label="否" value="0"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" :loading="buttonloading" class="btn" @click="getData()"><i class="el-icon-search"></i>查询</el-button>
              </el-form-item>
              <el-form-item>
                <el-button type="danger" :loading="buttonloading" class="btn" @click="resetting()"><i class="el-icon-refresh"></i>重置</el-button>
              </el-form-item>
            </el-form>
          </el-header>
          <el-main class="elMain">
            <el-table v-loading="loading" :data="tableData" height="100%" stripe border size="medium">
              <!---->
              <el-table-column type="expand">
                <template slot-scope="props">
                  <el-table :data="props.row.goodsList" style="width: 100%">
                    <el-table-column
                      prop="name"
                      label="商品图片"
                      width="180">
                      <template slot-scope="scope">
                        <img :src="scope.row.image" alt="" style="width: 50%;">
                      </template>
                    </el-table-column>
                    <el-table-column
                      prop="name"
                      label="商品名称"
                      width="180">
                    </el-table-column>
                    <el-table-column
                      prop="money"
                      label="商品单价"
                      width="180">
                    </el-table-column>
                    <el-table-column
                      prop="number"
                      label="购买数量"
                      width="180">
                    </el-table-column>
                    <el-table-column
                      prop="smoney"
                      label="商品总价"
                      width="180">
                      <template slot-scope="scope">
                        {{scope.row.number*scope.row.money}}
                      </template>
                    </el-table-column>
                  </el-table>
                </template>
              </el-table-column>
              <!---->
              <el-table-column align="center" label="订单号" prop="id" width="210" sortable></el-table-column>
              <el-table-column align="center" label="订单状态" prop="type" width="80">
                <template slot-scope="scope">
                  <span style="color: green;" v-if="scope.row.type=='0'">待付款</span>
                  <span style="color: green;" v-else-if="scope.row.type=='1'">待发货</span>
                  <span style="color: green;" v-else-if="scope.row.type=='2'">待收货</span>
                  <span style="color: green;" v-else-if="scope.row.type=='3'">已收货/等待评价</span>
                  <span style="color: green;" v-else-if="scope.row.type=='4'">已完成</span>
                  <span style="color: green;" v-else-if="scope.row.type=='6'">备货中</span>
                  <span style="color: green;" v-else-if="scope.row.type=='-1'">已取消</span>
                  <span style="color: green;" v-else-if="scope.row.type=='5'">退款中（等待商家确认）</span>
                  <span style="color: green;" v-else-if="scope.row.type=='7'">退款成功/已取消</span>
                  <span style="color: green;" v-else-if="scope.row.type=='8'">退款驳回</span>
                  <span style="color: red;" v-else-if="scope.row.type=='-2'">用户删除</span>
                </template>
              </el-table-column>
              <el-table-column align="center" label="下单时间" prop="time" width="100">
                <template slot-scope="scope">
                  <span v-for="time in scope.row.timeList" :key="time.time">
                    <span v-if="time.type=='0'">
                      {{time.time*1 | formatDate}}
                    </span>
                  </span>
                </template>
              </el-table-column>
              <el-table-column align="center" label="付款时间" prop="payment_time" width="100">
                <template slot-scope="scope">
                  <span v-for="time in scope.row.timeList" :key="time.time">
                    <span v-if="time.type=='1'">
                      {{time.time*1 | formatDate}}
                    </span>
                  </span>
                </template>
              </el-table-column>
              <el-table-column align="center" label="发货时间" prop="shipment_time" width="100">
                <template slot-scope="scope">
                  <span v-for="time in scope.row.timeList" :key="time.time">
                    <span v-if="time.type=='2'">
                      {{time.time*1 | formatDate}}
                    </span>
                  </span>
                </template>
              </el-table-column>
              <el-table-column align="center" label="成交时间" prop="success_time" width="100">
                <template slot-scope="scope">
                  <span v-for="time in scope.row.timeList" :key="time.time">
                    <span v-if="time.type=='3'">
                      {{time.time*1 | formatDate}}
                    </span>
                  </span>
                </template>
              </el-table-column>
              <el-table-column align="center" label="收货人" prop="consignee" width="120"></el-table-column>
              <el-table-column align="center" label="收货电话" prop="phone" width="150"></el-table-column>
              <el-table-column align="center" label="收货地址" prop="address"></el-table-column>
              <el-table-column align="center" label="总价" prop="sum_money" width="130">
                <template slot-scope="scope">
                  <span style="color: #ff6105;">
                    ￥{{scope.row.sum_money}}
                  </span>
                </template>
              </el-table-column>
              <el-table-column align="center" label="退款金额" prop="refund_money" width="110">
                <template slot-scope="scope">
                  <span>
                    ￥{{scope.row.refund_money}}
                  </span>
                </template>
              </el-table-column>
              <el-table-column align="center" label="是否配送" prop="peisong" width="80">
                <template slot-scope="scope">
                  <span style="color: green;" v-if="scope.row.peisong=='1'">
                    是
                  </span>
                  <span style="color: red;" v-else>
                    否
                  </span>
                </template>
              </el-table-column>
              <el-table-column fixed="right" label="操作" width="100">
                <template slot-scope="scope">
                  <span>
                    <el-button size="small" :loading="buttonloading" @click="openOrderInfor(scope.row.id)">查看</el-button>
                  </span>
                </template>
              </el-table-column>
            </el-table>
          </el-main>
          <el-footer>
            <div style="padding: 15px 0;text-align: right;">
              <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="formInline.pageNum"
                :page-sizes="pageSizes" :page-size="formInline.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="pageTotal">
              </el-pagination>
            </div>
          </el-footer>
        </el-container>
      </div>
    </div>
</template>

<script>
  import {commonAPI} from '@/api/commonAPI'
  export default {
    data() {
      return {
        //按钮的加载状态
        buttonloading:false,
        //订单详情
        orderxx:{},
        loadingxx:false,
        orderinforList:'',
        options:[{
            value: '',
            label: '全部订单',
          },{
            value: '0',
            label: '待付款',
          },{
            value: '1',
            label: '待发货',
          },{
            value: '2',
            label: '待收货',
          },{
            value: '3',
            label: '已收货',
          },{
            value: '4',
            label: '已完成',
          },{
            value: '6',
            label: '备货中',
          },{
            value: '-1',
            label: '已取消',
          },{
            value: '5',
            label: '退款中',
          },{
            value: '7',
            label: '已退款',
          },{
            value: '-2',
            label: '用户删除',
          }],
        data:'',
        tableData: [],
        loading: false,
        formInline: {
          id:'',
          phone:'',
          type:'',
          peisong:'',
          pageNum:1,
          pageSize:10,
          //time:'20210414'
        },
        pageSizes:[5, 10, 15, 20],
        pageTotal:0,
        AddForm:{
          id:'',
          money:'',
          type:'',
          goodsList:[],
        },
      }
    },

    filters: {
          formatDate: function (value) {
            /*返回总体日期*/
            let date = new Date(value);
            let y = date.getFullYear();
            let MM = date.getMonth() + 1;
            MM = MM < 10 ? ('0' + MM) : MM;
            let d = date.getDate();
            d = d < 10 ? ('0' + d) : d;
            let h = date.getHours();
            h = h < 10 ? ('0' + h) : h;
            let m = date.getMinutes();
            m = m < 10 ? ('0' + m) : m;
            let s = date.getSeconds();
            s = s < 10 ? ('0' + s) : s;
            //return y + '-' + MM + '-' + d + ' ' + h + ':' + m + ':' + s;
            /*返回判断日期*/
            let timestamp = (new Date()).valueOf();
            let time=timestamp-value;//时间差
            let minute = 1000*60;
            let hour = minute * 60;
            var day = hour * 24;
            let times="";//内容
            let min = time/minute;//分钟
            let hours = time/hour;//天数
            return y + '-' + MM + '-' + d + ' ' + h + ':' + m + ':' + s;
          }
        },

    created() {
      //this.getData();
    },
    //页面开启时执行
    mounted(){
      this.getData();
    },
    methods: {
      //数据治理IF
      dataIF(data){
        if(data.type=="0"){
          data.type_C="待付款";
        }else if(data.type=="1"){
          data.type_C="待发货";
        }else if(data.type=="2"){
          data.type_C="待收货";
        }else if(data.type=="3"){
          data.type_C="已收货";
        }else if(data.type=="4"){
          data.type_C="已完成";
        }else if(data.type=="5"){
          data.type_C="退款中";
        }else if(data.type=="6"){
          data.type_C="备货中";
        }else if(data.type=="7"){
          data.type_C="已退款";
        }else if(data.type=="-1"){
          data.type_C="已取消";
        }else if(data.type=="-2"){
          data.type_C="用户删除";
        }else{
          data.type_C="未找到相关依据";
        }
        //
        if(data.shopname==""){
          data.shopname="个人订单";
        }
        //
        if(data.peisong=="1"){
          data.peisong="是";
        }else{
          data.peisong="否";
        }
        //
        let timelist=data.timeList;
        for(let i=0;i<timelist.length;i++){
          if(data.timeList[i].type=="0"){
            data.time1=this.formatDate(data.timeList[i].time*1);
          }
          if(data.timeList[i].type=="4"){
            data.time2=this.formatDate(data.timeList[i].time*1);
          }
        }
      },
      //数据治理
      cleanDataOrder(data){
        let datalist=data;
        for(let i=0;i<datalist.length;i++){
          this.dataIF(datalist[i]);
        }
        return datalist;
      },
      //导出表格
      exportExcel() {
        if(this.tableData.length<=0){
          this.$notify({//这里采用element ui的一个错误显示效果模板
                title: '提示',
                message: '没有数据可以导出',
                position: 'bottom-right',
                type: 'error'
          });
          return false;
        }
        require.ensure([], () => {
            let myDate = new Date();
            const { export_json_to_excel } = require('../../../excel/Export2Excel');
            const tHeader = ['订单号','下单时间','成交时间','商户名称','收货人','电话','收货地址','订单总价','退款金额','状态','是否配送'];
            // 上面设置Excel的表格第一行的标题
            const filterVal = ['id','time1','time2','shopname','consignee','phone','address','sum_money','refund_money','type_C','peisong'];
            // 上面的index、nickName、name是tableData里对象的属性
            const list = this.tableData;  //把data里的tableData存到list
            const data = this.formatJson(filterVal, this.cleanDataOrder(list));
            export_json_to_excel(tHeader, data, '订单表'+'_'+myDate.toLocaleDateString());
          })
        },

      formatJson(filterVal, jsonData) {
        return jsonData.map(v => filterVal.map(j => v[j]))
      },
      //管理员进行自提用户收货
      //输入订单咨询内容
      NoPeisongOrderShouHuo(datas){
        this.$prompt('请输入取货码：', '订单收货', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          inputType:'text',
          inputPlaceholder:'请输入取货码',
          inputPattern:/^[\S\n\s]{1,10}$/ ,
          inputErrorMessage: '请填写取货码,且不超过10个字符'
        }).then(({ value }) => {
          datas.img="";
          datas.admin_id=this.$store.state.a_id;
          datas.codes=value;
          commonAPI('OrderShouHuo', datas).then(res => {
            let data = res.data;
              //console.log(res.data.rows);
              if(this.response.response(data)){
                this.getData();
                this.closeRE();
                this.getOrderInforList(datas.id);
              }
            }).catch(error=>{
              this.loading = false;
              this.$notify({//这里采用element ui的一个错误显示效果模板
                title: '提示',
                message: error.message,
                position: 'bottom-right',
                type: 'error'
          });
          });
          })
      },
      //管理员对用户重新获取取货码
      UserGetCode(data){
        this.$confirm('是否重新发送取货码？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          data.img="";
          this.buttonloading=true;
          data.admin_id=this.$store.state.a_id;
          commonAPI('UserGetCode', data).then(res => {
            let datas = res.data;
            if(this.response.response(datas)){
              this.getData();
              this.closeRE();
              this.getOrderInforList(data.id);
            }
              }).catch(error=>{
                this.$notify({//这里采用element ui的一个错误显示效果模板
                  title: '提示',
                  message: error.message,
                  position: 'bottom-right',
                  type: 'error'
                });
            })
          })
      },
      //管理员发货
      FaHuoOrder(data){
        this.$confirm('是否发货？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          data.img="";
          this.buttonloading=true;
          data.admin_id=this.$store.state.a_id;
          commonAPI('updateOrdersFaHuo', data).then(res => {
            let datas = res.data;
            if(this.response.response(datas)){
              this.getData();
              this.closeRE();
              this.getOrderInforList(data.id);
            }
              }).catch(error=>{
                this.$notify({//这里采用element ui的一个错误显示效果模板
                  title: '提示',
                  message: error.message,
                  position: 'bottom-right',
                  type: 'error'
                });
            })
          })
      },
      //管理员商品备货开始
      BeiHuoOrder(data){
        this.$confirm('是否开始备货？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          data.img="";
          this.buttonloading=true;
          data.admin_id=this.$store.state.a_id;
          data.goodsList="";
          commonAPI('updateOrdersBeiHuo', data).then(res => {
            let datas = res.data;
            if(this.response.response(datas)){
              this.getData();
              this.closeRE();
              this.getOrderInforList(data.id);
            }
              }).catch(error=>{
                this.$notify({//这里采用element ui的一个错误显示效果模板
                  title: '提示',
                  message: error.message,
                  position: 'bottom-right',
                  type: 'error'
                });
            })
          })
      },
      //管理员进行驳回退款申请
      ANORefundOrder(data){
        this.$confirm('是否需要驳回退款操作？', '提示', {
          confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            data.img="";
            this.buttonloading=true;
            data.admin_id=this.$store.state.a_id;
            commonAPI('ANORefundOrders', data).then(res => {
              let datas = res.data;
              if(this.response.response(datas)){
                this.getData();
                this.closeRE();
                this.getOrderInforList(data.id);
              }
              }).catch(error=>{
                      this.$notify({//这里采用element ui的一个错误显示效果模板
                      title: '提示',
                      message: error.message,
                      position: 'bottom-right',
                      type: 'error'
                    });
            })
          })
      },
      //进行管理员操作退款
      ARefundOrder(){
        if(this.AddForm.id==''||this.AddForm.money==''||this.AddForm.type==''){
          this.$message.error('内容有误，请选择完整内容！！');
          return false;
        }
        this.buttonloading=true;
        this.AddForm.admin_id=this.$store.state.a_id;
        for(let i=0;i<this.AddForm.goodsList.length;i++){
          this.AddForm.goodsList[i].image="";
        }
        this.AddForm.u_id=this.orderinforList.u_id;
        commonAPI('ARefundOrders',this.AddForm).then(res => {
          let data = res.data;
          //console.log(res.data.rows);
          if(this.response.response(data)){
            this.getData();
            this.getOrderInforList(this.AddForm.id);
            this.closeRE();
            this.buttonloading=false;
          }
        }).catch(error=>{
            this.loading = false;
            this.$notify({//这里采用element ui的一个错误显示效果模板
              title: '提示',
              message: error.message,
              position: 'bottom-right',
              type: 'error'
            });
            })
      },
      //关闭退款模式
      closeRE(){
        this.AddForm.id='';
        this.AddForm.money='';
        this.AddForm.type='';
        document.getElementById('AddForm_orderI').style.display='none';
      },
      //打开退款模式
      openRE(data){
        this.AddForm.id=data.id;
        this.AddForm.goodsList=data.goodsList;
        this.AddForm.money=data.sum_money;
        document.getElementById('AddForm_orderI').style.display='block';
      },
      //价钱浮动计算方法
      getFmoney(money,discount){
        let m=0,s1=money.toString(),s2=discount.toString(),sum=0;
        try{m+=s1.split(".")[1].length}catch(e){}
        try{m+=s2.split(".")[1].length}catch(e){}
        sum=Number(s1.replace(".",""))*Number(s2.replace(".",""))/Math.pow(10,m);
        return sum.toFixed(2);
      },
      //获取订单详情
      getOrderInforList(id){
        this.loadingxx=true;
        if(id==''||id=='null'||id=='undefined'){
          this.loadingxx=false;
          return false;
        }
        this.orderxx.id=id;
        this.orderxx.pageNum=1;
        this.orderxx.pageSize=1;
        commonAPI('queryOrders_list_infor', this.orderxx).then(res => {
          this.orderinforList=res.data.data.rows[0];
          this.loadingxx=false;
        })
      },
      //打开或者关闭订单详情
      openOrderInfor(data){
        this.getOrderInforList(data);
        document.getElementById('Orderinformain_orderI').style.display='block';
        document.getElementById('zhedang').style.display='block';
      },
      closeOrderInformation(){
        this.orderinforList='';
        this.orderxx.order_id='';
        document.getElementById('Orderinformain_orderI').style.display='none';
        document.getElementById('zhedang').style.display='none';
      },
      //重置查询
      resetting() {
        this.formInline.id = '';
        this.formInline.phone = '';
        this.formInline.type = '';
        this.formInline.peisong = '';
        this.getData();
      },
      //查询
      getData() {
        this.loading = true,
          commonAPI('queryOrders_list_one',this.formInline).then(res => {
            this.loading = false;
            this.buttonloading=false;
            this.tableData = res.data.data.rows;
            this.pageTotal=res.data.data.total;
            //console.log(res.data.rows);
          })
      },
      onSubmit() {
        this.getData();
      },
      handleSizeChange(val) {
        //console.log(`每页 ${val} 条`);
        this.formInline.pageSize=val;
        this.formInline.pageNum=1;
        this.getData();
      },
      handleCurrentChange(val) {
        //console.log(`当前页: ${val}`);
        this.formInline.pageNum=val;
        this.getData();
      },
      //进行订单的最新状态
      getNewTypetime(data){
        if(data==''||data==null||data=='undefined'){
          return false;
        }
        let text="时间："+this.formatDate(data.time*1)+"         当前状态："+this.PDTimeType(data.type);
        return text;
      },
      //判定订单当前时间状态
      PDTimeType(data){
        let text='';
        if(data=='0'){
          text='订单创建';
        }else if(data=='1'){
          text='订单付款';
        }else if(data=='2'){
          text='订单发货';
        }else if(data=='3'){
          text='订单成交';
        }else if(data=='4'){
          text='订单完成';
        }else if(data=='5'){
          text='订单退款中';
        }else if(data=='6'){
          text='订单备货中';
        }else if(data=='7'){
          text='订单退款';
        }else if(data=='8'){
          text='订单退款申请驳回';
        }else if(data=='-1'){
          text='订单取消';
        }
        return text;
      },
      //时间转换
      formatDate: function (value) {
        /*返回总体日期*/
        let date = new Date(value);
        let y = date.getFullYear();
        let MM = date.getMonth() + 1;
        MM = MM < 10 ? ('0' + MM) : MM;
        let d = date.getDate();
        d = d < 10 ? ('0' + d) : d;
        let h = date.getHours();
        h = h < 10 ? ('0' + h) : h;
        let m = date.getMinutes();
        m = m < 10 ? ('0' + m) : m;
        let s = date.getSeconds();
        s = s < 10 ? ('0' + s) : s;
        //return y + '-' + MM + '-' + d + ' ' + h + ':' + m + ':' + s;
        /*返回判断日期*/
        let timestamp = (new Date()).valueOf();
        let time=timestamp-value;//时间差
        let minute = 1000*60;
        let hour = minute * 60;
        var day = hour * 24;
        let times="";//内容
        let min = time/minute;//分钟
        let hours = time/hour;//天数
        return y + '-' + MM + '-' + d + ' ' + h + ':' + m + ':' + s;
      },
    }
  }
</script>

<style scoped>
  .elInput,
  .btn {
    margin-top: 0px;
  }
  .el-main {
    padding: 5px 10px;
  }
  .elMain{
    height: 700px;
  }
  .el-table th {
    height: 45px;
    font-size: 16px;
    font-family: 微软雅黑;
    font-weight: 500;
    color: darkblue;
  }
  .flex{
    /*flex 布局*/
    display: flex;
    /*实现垂直居中*/
    align-items: center;
    /*实现水平居中*/
    justify-content: center;
    text-align: justify;
  }
  /**Orderinfor框架*/
  .Orderinfordiv{
    position: fixed;
    top: 13%;
    left:0;
    right:0;
    bottom: 0;
    margin:0 auto;
    padding: 20px;
    border: 0px solid #ddd;
    z-index:23;
    overflow: auto;
    display: none;
  }
  .OrderinforForm{
    margin: 0 auto;
    width: 900px;
    background-color: #fff;
    -webkit-box-shadow: #333 0px 5px 5px;
    -moz-box-shadow: #333 0px 5px 5px;
    box-shadow: #333 0px 5px 5px;
  }
  .OrderinforForm a{
    color: #fff;
  }
  .OrderinforForm a:hover{
    color: #d6d6d6;
  }
  .orderxx_p{
  	margin:0px 0 5px 0;
  	color:#909090;
  }

   .playlistbox_botton{
      width: 900px;
      margin: 0 auto;
      overflow: hidden;
      height: 633px;
      overflow-y: scroll;
    }
    /**滚动条样式*/
    .playlistbox_botton::-webkit-scrollbar{
      width: 5px;
    }
    .playlistbox_botton::-webkit-scrollbar-thumb{
      border-radius: 10px;
      -webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2);
      background: #535353;
    }
    .playlistbox_botton::-webkit-scrollbar-thumb{
      -webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2);
      border-radius: 10px;
      background: #EDEDED;
    }
    /**登录框架*/
    .logindiv{
      position: fixed;
      top: 25%;
      left:0;
      right:0;
      bottom: 0;
      margin:0 auto;
      padding: 20px;
      border: 0px solid #ddd;
      z-index:25;
      overflow: auto;
      text-align: center;
      display: none;
    }
    .loginForm{
      margin: 0 auto;
      width: 550px;
      background-color: #fff;
      -webkit-box-shadow: #333 0px 5px 5px;
      -moz-box-shadow: #333 0px 5px 5px;
      box-shadow: #333 0px 5px 5px;
    }
    .loginForm a{
      color: #fff;
    }
    .loginForm a:hover{
      color: #d6d6d6;
    }

</style>



// WEBPACK FOOTER //
// src/admin/views/order/OrderList.vue